export const articleCrackImages = {
  preview: '/images/insikter/crack-portal.jpg',
  detail: '/images/insikter/crack-detail.jpg',
};
